import request from '@/utils/request';
export function getStockValueReport(params) {
  return request.get('/reports/stock-value', {
    params
  });
}
export function getTotalStockValue(params) {
  return request.get('/reports/get-total-stock-value', {
    params
  });
}